export const CURRENT_USER_RETRY_COUNT = 3;

export const ERROR_MESSAGE_FALLBACK =
  'Something went wrong while loading your account.';
